import { PumpTimelineMessages, TranslationPumpTimelineMessages } from "../interfaces";

export const messages: TranslationPumpTimelineMessages = {
  [PumpTimelineMessages.state]: "Estado",
  [PumpTimelineMessages.destination]: "Destino",
  [PumpTimelineMessages.driver]: "Motorista",
  [PumpTimelineMessages.tooltipSpeedThreshold]: "Velocidade máxima: ",
  [PumpTimelineMessages.tooltipGenerateAt]: "Gerado"
};
